import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validator to check if a string has only whitespaces
 */
export function notOnlyWhitespaces(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) {
            return null;
        }

        if (control.value.length > 0 && control.value.trim().length === 0) {
            return { onlySpaces: true };
        }

        return null;
    };
}
